var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7,
  height: 10,
  viewBox: "0 0 7 10"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-70.573)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(70.573)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.073,0a3.566,3.566,0,0,0-3.5,3.622c0,2.478,3.132,6.117,3.266,6.27a.308.308,0,0,0,.469,0c.133-.154,3.266-3.792,3.266-6.27A3.566,3.566,0,0,0,74.073,0Zm0,5.444a1.794,1.794,0,0,1-1.761-1.822,1.762,1.762,0,1,1,3.522,0A1.794,1.794,0,0,1,74.073,5.444Z",
  transform: "translate(-70.573)"
})))));
export default __webpack_public_path__ + "static/media/pin.a4241846.svg";
export { SvgComponent as ReactComponent };